import _ from 'lodash'

export default function (action, args, displayId, payload) {
    console.log('cart-rule-action:redirect', { action, args })

    payload.redirect = window.addiesaas.$fn.formatters.templify(action.options.redirect, args)
}
